module.exports = __webpack_public_path__ + "media/images/logo/logo-prex-white-59e4480171563483a1571c8bc1b97e76.svg";